import React, {memo} from 'react';

// import useStyles from './useStyles';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material'

export const SimpleDialog = memo((props) => {

    const {
        onClose,
        title = "",
        text = "",
        open,
        okText = "OK"
    } = props;

    const handleOk = () => {
        onClose();
    };

    return (
        <Dialog
            sx={{'& .MuiDialog-paper': {width: '80%', maxHeight: "80%"}}}
            maxWidth="xs"
            open={open}
        >
            {title && (
                <DialogTitle>{title}</DialogTitle>
            )}

            {text && (
                <DialogContent>
                    { text }
                </DialogContent>
            )}

            <DialogActions>
                <Button onClick={handleOk} autoFocus>
                    {okText}
                </Button>
            </DialogActions>
        </Dialog>
    );
})